package chand.wordvoyage.repository

sealed class AuthState {
    object Loading : AuthState()
    object NotAuthenticated : AuthState()
    data class Authenticated(val userId: String, val email: String) : AuthState()
}

interface AuthRepository {
    fun getCurrentUser(): AuthState
    suspend fun signInWithGoogle(idToken: String): Result<AuthState>
    fun signOut()
    suspend fun deleteAccount(): Result<Unit>
}

